import React from 'react';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

interface SideMenuIconButtonProps {
    isOpen: boolean;
    onClick: (e: React.MouseEvent) => void;
    size?: 'small' | 'medium' | 'large';
    ariaLabel?: string;
}

/**
 * SVG-based expand/collapse icon button using sidemenu icons from ps_categorytree
 * with CSS hover effects
 */
const SideMenuIconButton: React.FC<SideMenuIconButtonProps> = ({
    isOpen,
    onClick,
    size = 'small',
    ariaLabel = isOpen ? 'Collapse' : 'Expand',
}) => {
    const theme = useTheme();

    // Construct asset paths - adjust these based on your deployment structure
    const getAssetPath = (filename: string): string => {
        // Try to get the themes path from the current location
        // Falls back to root-relative path
        return `/themes/uc_base_theme/assets/img/${filename}`;
    };

    const minusIconDefault = getAssetPath('sidemenu-minus-icon.svg');
    const minusIconHover = getAssetPath('sidemenu-minus-icon-hover.svg');
    const plusIconDefault = getAssetPath('sidemenu-plus-icon.svg');
    const plusIconHover = getAssetPath('sidemenu-plus-icon-hover.svg');

    return (
        <IconButton
            // disableRipple
            size={size}
            onClick={onClick}
            edge="start"
            sx={{
                color: theme.palette.primary.main,
                position: 'relative',
                padding: '8px',
            }}
            aria-label={ariaLabel}
            className="sidemenu-icon-button"
        >
            <div className="svg-container" style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                {isOpen ? (
                    <>
                        {/* Minus icon container */}
                        <img
                            className="svg-icon svg-default"
                            src={minusIconDefault}
                            alt="Collapse"
                            style={{
                                width: '24px',
                                height: '24px',
                                display: 'block',
                            }}
                        />
                        <img
                            className="svg-icon svg-hover"
                            src={minusIconHover}
                            alt="Collapse hover"
                            style={{
                                position: 'absolute',
                                width: '24px',
                                height: '24px',
                                display: 'block',
                            }}
                        />
                    </>
                ) : (
                    <>
                        {/* Plus icon container */}
                        <img
                            className="svg-icon svg-default"
                            src={plusIconDefault}
                            alt="Expand"
                            style={{
                                width: '24px',
                                height: '24px',
                                display: 'block',
                            }}
                        />
                        <img
                            className="svg-icon svg-hover"
                            src={plusIconHover}
                            alt="Expand hover"
                            style={{
                                position: 'absolute',
                                width: '24px',
                                height: '24px',
                                display: 'block',
                            }}
                        />
                    </>
                )}
            </div>
        </IconButton>
    );
};

export default SideMenuIconButton;


